var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideocall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lineal-fill",
    d: "M256 21.33v160a21.39 21.39 0 01-21.33 21.33H186a55.9 55.9 0 00-55.36-48H128V149a63.52 63.52 0 0016-22.08v27.73h96V29.33A13.33 13.33 0 00226.67 16h-69.33A13.33 13.33 0 00144 29.33v46.72a62.68 62.68 0 00-16-22.19V21.33A21.39 21.39 0 01149.33 0h85.33A21.4 21.4 0 01256 21.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "primary-fill",
    d: "M192 85.33a16 16 0 1116-16 16 16 0 01-16 16zM216 128h-48a8 8 0 01-8-8 24 24 0 0124-24h16a24 24 0 0124 24 8 8 0 01-8 8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "primary-fill",
    d: "M162.67 256H8a8 8 0 01-8-8v-37.33a40 40 0 0140-40h90.67a40 40 0 0140 40V248a8 8 0 01-8 8zM38.4 91.73a1.8 1.8 0 01.11-.75 48 48 0 0193.76.32c0 .11.11.32.11.43s-.32.11-.43.11C114 96.64 102.4 77.12 102 76.27a5.32 5.32 0 00-3.84-2.56 5.42 5.42 0 00-4.48 1.39c-22.62 21-52.81 17-55.26 16.63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "primary-fill",
    d: "M126.08 103.25c-14.4 0-24.64-10-29.76-16.43-24.32 19.08-53 16.32-58.88 15.56a21.89 21.89 0 00.21 4.6 48 48 0 0095.36-.32 18.89 18.89 0 00.21-4.28 26.93 26.93 0 01-7.14.87z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideocall);
export default __webpack_public_path__ + "static/media/videocall.0fb4cd8b82bfc5e38c33be25b43a03f6.svg";
export { ForwardRef as ReactComponent };